"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClosestDelivery = exports.useStoreStatus = exports.useStoreDetailsByLocation = exports.useStoreDetails = exports.useStoreSearch = void 0;

var _tslib = require("tslib");

var _useRequest = _interopRequireDefault(require("../useRequest/useRequest"));

var _storeUtils = require("./storeUtils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var useStoreSearch = function useStoreSearch(query, isLegacy, locale, isAsync) {
  if (isLegacy === void 0) {
    isLegacy = false;
  }

  if (locale === void 0) {
    locale = 'en-US';
  }

  if (isAsync === void 0) {
    isAsync = false;
  }

  return (0, _useRequest["default"])({
    method: 'get',
    path: 'stores',
    params: isLegacy ? {
      searchString: query
    } : (0, _storeUtils.getLocationObject)(query, locale)
  }, isAsync);
};

exports.useStoreSearch = useStoreSearch;

var useStoreDetails = function useStoreDetails(id, isAsync) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  return (0, _useRequest["default"])({
    method: 'get',
    path: "stores/" + id
  }, isAsync);
};

exports.useStoreDetails = useStoreDetails;

var useStoreDetailsByLocation = function useStoreDetailsByLocation(location, isAsync) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  return (0, _useRequest["default"])({
    method: 'get',
    path: "store/location/" + location
  }, isAsync);
};

exports.useStoreDetailsByLocation = useStoreDetailsByLocation;

var useStoreStatus = function useStoreStatus(params, isAsync) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  return (0, _useRequest["default"])({
    method: 'post',
    path: 'stores/storeorderingstatus',
    params: (0, _tslib.__assign)({}, params)
  }, isAsync);
};

exports.useStoreStatus = useStoreStatus;

var useClosestDelivery = function useClosestDelivery(params, isAsync) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  return (0, _useRequest["default"])({
    method: 'post',
    path: 'getclosestdeliveryStore',
    params: {
      deliveryAddress: (0, _tslib.__assign)({}, params)
    }
  }, isAsync);
};

exports.useClosestDelivery = useClosestDelivery;